import React from 'react'
import { Link } from 'react-router-dom'

type Props = {}

export function Navigation({}: Props) {
  return (
    <nav className='flex justify-between items-center  h-[50px] px-5 shadow-md bg-gray-500 text-white'>
        <h3>GitHub Search</h3>
        <span>
            <Link  className='mr-2' to="/">Главная</Link>
            <Link  className='mr-2'  to="/favorites">Избранное</Link>
        </span>

    </nav>
  )
}